import { m } from '~/paraglide/messages'

export type TrialTimelineIcon = 'unlock' | 'bell' | 'star'

export type TrialTimelineRow = {
  icon: TrialTimelineIcon
  title: typeof m.subscription_walkthrough_p3_today
  note: typeof m.subscription_walkthrough_p3_today_note
}

export function getTrialTimelineRows(): TrialTimelineRow[] {
  return [
    {
      icon: 'unlock',
      title: m.subscription_walkthrough_p3_today,
      note: m.subscription_walkthrough_p3_today_note,
    },
    {
      icon: 'bell',
      title: m.subscription_walkthrough_p3_1_day_before_trail,
      note: m.subscription_walkthrough_p3_1_day_before_trail_note,
    },
    {
      icon: 'star',
      title: m.subscription_walkthrough_p3_trail_end,
      note: m.subscription_walkthrough_p3_trail_end_note,
    },
  ]
}
